import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WizardFormData } from './schemas';
import { WizardAutocompleteField, WizardToggleField } from './components';
import AutoCreateCampaignForm from './components/AutoCreateCampaignForm';
import { useWizardData } from './hooks/useWizardData';
import CampaignOfferSettings from './components/CampaignOfferSettings';

function CampaignStep() {
  const { watch } = useFormContext<WizardFormData>();
  const { entryDomains, offerGroups, campaigns } = useWizardData();

  const autoCreateCampaign = watch('autoCreateCampaign');

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Campaign Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure campaign settings for your offer.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <WizardToggleField label="Automatically create campaign" name="autoCreateCampaign" helperText="Automatically create a campaign for the offer" />

        <Box sx={{ ml: 4 }}>
          {autoCreateCampaign ? (
            <AutoCreateCampaignForm entryDomains={entryDomains} offerGroups={offerGroups} />
          ) : (
            <WizardAutocompleteField
              label="Campaign"
              name="selectedCampaignId"
              options={campaigns.map((campaign) => ({
                id: campaign._id,
                label: campaign.name,
              }))}
            />
          )}

          <CampaignOfferSettings />
        </Box>
      </Box>
    </Box>
  );
}

export default CampaignStep;
